import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import './ImportProdutoEanMassa.css'
import {
  PageHeader,
  Btn,
  CustomPanel,
  ExcelModeloBuilder,
  ImportExcelFile,
  SelectEmpresas,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { saveProductsEanMassively } from '../../../../services/api/https/system/system.http'

function ImportProdutoEanMassa({ dispatch, history }) {
  // tipo_embalagem é opcional (ex.: UN, PCT, CX_MASTER) e vale só para EANs novos: os
  // já cadastrados continuam ignorados. Planilhas antigas, sem a coluna, seguem válidas.
  const modeloExcel = [['codigo_produto', 'ean', 'qte_caixa', 'tipo_embalagem']]

  const [state, setState] = useState({
    loading: true,
    produtos: [],
    company_id: null,
  })

  const onBtnSalvarClicked = async () => {
    dispatch(showLoadingBox('Aguarde...', 'Carregando...'))
    try {
      setState(prevState => ({ ...prevState, loading: true }))
      const { produtos } = state
      if (produtos.length === 0) {
        throw new Error('Não existem Produtos para Importação')
      }
      const message = await saveProductsEanMassively(produtos)
      const messages = message.split('\n')

      dispatch(
        showMessageBox(
          messages[0] +
            `\n ${messages.length > 1 ? 'Existem produtos que não tiveram seus EANs associados. Verifique o console.' : ''}`,
          null,
        ),
      )
      setState(prevState => ({ ...prevState, loading: false, produtos: [] }))
    } catch (error) {
      setState(prevState => ({ ...prevState, loading: false }))
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }
  const onBtnVoltarClicked = () => {
    history.goBack()
  }
  const onFileImported = content => {
    try {
      if (!state.company_id) throw new Error('Selecione uma empresa.')

      const isPlanilhaNoPadrao = planilhaNoPadrao(content)
      if (!isPlanilhaNoPadrao) {
        throw new Error('Planilha Fora do Padrão. Baixe o Modelo e Verifique.')
      }

      const produtos = buildProdutos(content)
      setState(prevState => ({
        ...prevState,
        produtos,
      }))
    } catch (error) {
      dispatch(showMessageBox(null, error.message))
    }
  }

  const onEmpresaChange = value => {
    try {
      const id = typeof value === 'object' && value ? value.id : value
      if (!id) throw new Error('Seleção de empresa inválida.')
      const produtos = state.produtos.map(p => ({ ...p, company_id: id }))
      setState(prevState => ({ ...prevState, company_id: id, produtos }))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  // Helpers
  const normalize = v =>
    String(v != null ? v : '')
      .trim()
      .toLowerCase()

  const planilhaNoPadrao = content => {
    if (!Array.isArray(content) || content.length === 0) return false

    if (Array.isArray(content[0])) {
      const header = content[0].map(normalize)
      return header[0] === 'codigo_produto' && header[1] === 'ean' && header[2] === 'qte_caixa'
    }

    const keys = Object.keys(content[0] || {}).map(normalize)
    return keys.includes('codigo_produto') && keys.includes('ean') && keys.includes('qte_caixa')
  }

  const buildProdutos = content => {
    const { company_id } = state
    const result = []
    const erros = []

    const isCellEmpty = v => v == null || String(v).trim() === ''

    const fieldLabels = {
      codigo_produto: 'Código do Produto',
      ean: 'EAN',
      qte_caixa: 'Qte por Caixa',
    }
    const MAX_TIPO_EMBALAGEM = 20

    // Valida uma linha já identificada como não totalmente vazia.
    // Se algum campo obrigatório estiver em branco, registra o erro em vez de lançar,
    // para que possamos reportar todas as linhas inconsistentes de uma só vez.
    const processarLinha = (linhaPlanilha, { codigo_produto, ean, qte_caixa, tipo_embalagem }) => {
      const camposVazios = []
      if (isCellEmpty(codigo_produto)) camposVazios.push(fieldLabels.codigo_produto)
      if (isCellEmpty(ean)) camposVazios.push(fieldLabels.ean)
      if (isCellEmpty(qte_caixa)) camposVazios.push(fieldLabels.qte_caixa)

      if (camposVazios.length > 0) {
        erros.push({
          linha: linhaPlanilha,
          mensagem: `campo(s) em branco - ${camposVazios.join(', ')}`,
        })
        return
      }

      const tipoEmbalagem = isCellEmpty(tipo_embalagem)
        ? null
        : String(tipo_embalagem).trim().toUpperCase()
      if (tipoEmbalagem && tipoEmbalagem.length > MAX_TIPO_EMBALAGEM) {
        erros.push({
          linha: linhaPlanilha,
          mensagem: `tipo de embalagem com mais de ${MAX_TIPO_EMBALAGEM} caracteres`,
        })
        return
      }

      result.push({
        company_id,
        product_code: String(codigo_produto).trim(),
        ean: String(ean).trim(),
        qte_caixa: Number(qte_caixa),
        packaging_type: tipoEmbalagem,
      })
    }

    if (Array.isArray(content[0])) {
      const body = content.slice(1)
      for (let i = 0; i < body.length; i++) {
        const row = Array.isArray(body[i]) ? body[i] : []

        const allEmpty = row.length === 0 || row.every(cell => isCellEmpty(cell))
        if (allEmpty) continue

        const [codigo_produto, ean, qte_caixa, tipo_embalagem] = row
        processarLinha(i + 2, { codigo_produto, ean, qte_caixa, tipo_embalagem })
      }
    } else {
      for (let i = 0; i < content.length; i++) {
        const row = content[i] || {}

        const codigo_produto =
          row.codigo_produto != null ? row.codigo_produto : row.CODIGO_PRODUTO
        const ean = row.ean != null ? row.ean : row.EAN
        const qte_caixa =
          row.qte_caixa != null
            ? row.qte_caixa
            : row.QTE_CAIXA != null
              ? row.QTE_CAIXA
              : row.qtd_caixa

        const tipo_embalagem = row.tipo_embalagem != null ? row.tipo_embalagem : row.TIPO_EMBALAGEM

        const maybeAllEmpty =
          isCellEmpty(codigo_produto) &&
          isCellEmpty(ean) &&
          isCellEmpty(qte_caixa) &&
          isCellEmpty(tipo_embalagem)
        if (maybeAllEmpty) continue

        processarLinha(i + 2, { codigo_produto, ean, qte_caixa, tipo_embalagem })
      }
    }

    if (erros.length > 0) {
      const detalhes = erros.map(e => `Linha ${e.linha}: ${e.mensagem}`).join('\n')
      throw new Error(
        `Não foi possível importar a planilha. Corrija as linhas abaixo e importe novamente:\n${detalhes}`,
      )
    }

    return result
  }

  return (
    <div>
      <PageHeader>S.17 - Importação de Produtos EAN em Massa</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={onBtnVoltarClicked}>
          <div className="p-grid">
            <div className="p-col-12 p-md-3" style={{ paddingBottom: 8 }}>
              <SelectEmpresas
                companyId={state.company_id}
                onChange={value => onEmpresaChange(value)}
              />
            </div>
            <div
              className="p-col-12 p-md-9"
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                gap: 10,
                flexWrap: 'wrap',
                paddingBottom: 8,
              }}
            >
              <ExcelModeloBuilder
                modeloColunas={modeloExcel}
                filename="ImportaoProdutosEan.xlsx"
              />
              <ImportExcelFile
                label="Importar"
                classes="btnImportar"
                onFileImported={onFileImported}
              />
              <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
            </div>
          </div>
          <div>
            <DataTable value={state.produtos} emptyMessage="Não existem produtos importados">
              <Column field="product_code" header="Código" style={tableCellCentered()} />
              <Column field="ean" header="EAN" style={tableCellCentered()} />
              <Column field="qte_caixa" header="Qte Por Caixa" style={tableCellCentered()} />
              <Column
                field="packaging_type"
                header="Embalagem"
                style={tableCellCentered()}
                body={p => p.packaging_type || '-'}
              />
            </DataTable>
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

export default connect()(withRouter(ImportProdutoEanMassa))
